import { useCallback, useEffect, useState } from 'react';
import { Webinar } from '../types/webinars';
import { fetchWebinars } from '../services/webinarsService';

interface UseWebinarsReturn {
    webinars: Webinar[];
    loading: boolean;
    error: Error | null;
    refetch: () => Promise<void>;
}

/**
 * Loads upcoming webinars for the public landing page. The service fails open
 * (returns an empty list) so the section can be hidden entirely when the CMS
 * returns no webinars or is unavailable.
 */
export function useWebinars(): UseWebinarsReturn {
    const [webinars, setWebinars] = useState<Webinar[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    const load = useCallback(async () => {
        try {
            setLoading(true);
            const data = await fetchWebinars();
            setWebinars(data);
            setError(null);
        } catch (err) {
            setError(err as Error);
            setWebinars([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return { webinars, loading, error, refetch: load };
}
